
class applicationSchoolSelector {
    init() {
        const applicationSchoolSelector = document.getElementById('applicationSchoolSelector');
        if (applicationSchoolSelector) {
            applicationSchoolSelector.addEventListener('change', function () {
                const selectedSchoolId = this.value;
                const url  = window.location.protocol + "//" 
                    + window.location.host 
                    + window.location.pathname 
                    + "?school=" + selectedSchoolId;
                window.location.href = url;
            });
        }
    }
};
export default applicationSchoolSelector;